<div class="media-preview-container">
  <!-- Header -->
  <div class="media-preview-header">
    <button mat-icon-button (click)="goBack()" class="close-button">
      <mat-icon>arrow_back</mat-icon>
    </button>

    @if (fileInfo) {
    <div class="file-info">
      <h2>{{ fileInfo.display_name || fileInfo.original_name }}</h2>
      <div class="file-meta">
        <span class="file-size">{{ getFileSize() }}</span>
        <span class="file-date">{{ getFileDate() }}</span>
      </div>
    </div>
    }

    <button
      mat-raised-button
      color="primary"
      (click)="downloadFile()"
      class="download-button"
    >
      <mat-icon>download</mat-icon>
      Download
    </button>
  </div>

  <!-- Loading state -->
  @if (isLoading) {
  <div class="loading-container">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <p>Indlæser fil...</p>
  </div>
  }

  <!-- Error state -->
  @if (errorMessage) {
  <div class="error-container">
    <mat-icon class="error-icon">error</mat-icon>
    <p>{{ errorMessage }}</p>
    <button mat-raised-button color="primary" (click)="loadAndPreviewFile()">
      Prøv igen
    </button>
  </div>
  }

  <!-- File content -->
  @if (!isLoading && !errorMessage && fileInfo && (safeBlobUrl ||
  fileInfo.mime_type?.startsWith('video/'))) {
  <div class="media-content">
    <!-- Images -->
    @if (isImage()) {
    <div class="image-container">
      <img
        [src]="safeBlobUrl"
        [alt]="fileInfo.display_name || fileInfo.original_name"
        class="preview-image"
        (error)="errorMessage = 'Kunne ikke indlæse billede'"
      />
    </div>
    }
    <!-- PDFs -->
    @if (isPdf()) {
    <div class="pdf-container">
      <iframe
        [src]="safeBlobUrl"
        class="preview-pdf"
        type="application/pdf"
        (error)="errorMessage = 'Kunne ikke indlæse PDF'"
      >
        <p>
          Din browser understøtter ikke PDF visning.
          <a
            [href]="blobUrl"
            [download]="fileInfo.display_name || fileInfo.original_name"
            >Download PDF'en</a
          >
        </p>
      </iframe>
      @if (!supportsInlineViewing()) {
      <div class="pdf-fallback">
        <mat-icon>picture_as_pdf</mat-icon>
        <p>PDF kan ikke vises i din browser</p>
        <button mat-raised-button (click)="downloadFile()">
          <mat-icon>download</mat-icon>
          Download PDF
        </button>
      </div>
      }
    </div>
    }
    <!-- Debug Info removed for cleaner UI -->
    <!-- Videos (Created programmatically to avoid Angular timing issues) -->
    <!-- Video controls will be added dynamically by the video player -->
    <!-- Audio -->
    @if (isAudio()) {
    <div class="audio-container">
      <div class="audio-player">
        <mat-icon class="audio-icon">audiotrack</mat-icon>
        <div class="audio-info">
          <h3>{{ fileInfo.display_name || fileInfo.original_name }}</h3>
          <p class="audio-meta">
            {{ getFileSize() }} • {{ fileInfo.mime_type }}
          </p>
        </div>
        <audio
          [src]="safeBlobUrl"
          controls
          preload="metadata"
          class="preview-audio"
          (error)="errorMessage = 'Kunne ikke indlæse lydfil'"
        >
          <p>
            Din browser understøtter ikke lydafspilning.
            <a
              [href]="blobUrl"
              [download]="fileInfo.display_name || fileInfo.original_name"
              >Download lydfilen</a
            >
          </p>
        </audio>
      </div>
    </div>
    }
    <!-- Documents (Word, Excel, PowerPoint, etc.) -->
    @if (isDocument()) {
    <div class="document-container">
      <mat-icon class="document-icon">description</mat-icon>
      <h3>{{ fileInfo.display_name || fileInfo.original_name }}</h3>
      <p class="file-type">{{ fileInfo.mime_type }}</p>
      <p class="file-description">
        Denne dokumenttype kan ikke vises direkte i browseren.
      </p>
      <button mat-raised-button color="primary" (click)="downloadFile()">
        <mat-icon>download</mat-icon>
        Download dokument
      </button>
    </div>
    }
    <!-- Other unsupported files -->
    @if (isUnsupportedFile()) {
    <div class="unsupported-container">
      <mat-icon class="file-icon">insert_drive_file</mat-icon>
      <h3>{{ fileInfo.display_name || fileInfo.original_name }}</h3>
      <p class="file-type">{{ fileInfo.mime_type }}</p>
      <p class="file-description">Denne filtype kan ikke vises i browseren.</p>
      <button mat-raised-button color="primary" (click)="downloadFile()">
        <mat-icon>download</mat-icon>
        Download fil
      </button>
    </div>
    }
  </div>
  }

  <!-- Footer controls (hidden for videos to prevent blocking video controls) -->
  @if (!isLoading && !errorMessage && !(fileInfo &&
  fileInfo.mime_type?.startsWith('video/'))) {
  <div class="media-preview-footer">
    <button mat-button (click)="goBack()">
      <mat-icon>close</mat-icon>
      Luk
    </button>
    <button mat-raised-button color="primary" (click)="downloadFile()">
      <mat-icon>download</mat-icon>
      Download
    </button>
  </div>
  }
</div>
